import React, { useState, useEffect, useRef } from 'react';
import { Skeleton, SkeletonBlock, SkeletonLine, } from '@one-thd/sui-atomic-components';
import { HD_PASS_SUCCESS_AUTH_MSG } from '../../../constants/response-success-messages';
import { usePayments } from '../../../hooks/use-payments';
import { TAlertStatus } from '../../../models/common/alert-messages';
import { useCustomerInfo } from '../../../hooks/use-customerInfo';
import { getPaymentModalsVersion, getSiteKey, scrollToTop, } from '../../../utils/general';
import { useIframeResize } from '../../../hooks/use-iframe-resize';
import { MIN_IFRAME_BODY_HEIGHT } from '../../../constants/credit-card';
export const HDWalletAuth = ({ card, onCloseForm, onSuccess, canUseCardDetailsForm, }) => {
    const { role } = useCustomerInfo();
    const paymentModalsVersion = getPaymentModalsVersion();
    const HD_PASS_AUTH_IFRAME_URL = `/account/payment-ui/${paymentModalsVersion}/dist/client/hd-wallet-auth.html`;
    // use these urls for local development
    // const HD_PASS_AUTH_IFRAME_URL = '/modals/hd-wallet-auth.html';
    const { setAlertMessage } = usePayments();
    const iframeRef = useRef(null);
    const { iframeHeight, startObserving } = useIframeResize(MIN_IFRAME_BODY_HEIGHT);
    const [isIframeLoading, setIsIframeLoading] = useState(true);
    const sendDataToIframe = (data) => {
        var _a, _b;
        (_b = (_a = iframeRef.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage(data, window.origin);
    };
    useEffect(() => {
        const handleIFrameMessages = (event) => {
            if (event.origin.indexOf('homedepotdev.com') > -1 ||
                event.origin.indexOf('homedepot.com') > -1) {
                const data = event.data;
                if (data.stopLoadingSpinner) {
                    setIsIframeLoading(false);
                }
                if (data.loaded) {
                    sendDataToIframe({
                        event: 'experience data',
                        experienceProps: window === null || window === void 0 ? void 0 : window.__EXPERIENCE_PROPS__,
                        experienceContext: window === null || window === void 0 ? void 0 : window.__EXPERIENCE_CONTEXT__,
                        data: {
                            siteKey: getSiteKey(true),
                            role,
                        },
                    });
                    sendDataToIframe({
                        event: 'card',
                        data: {
                            card,
                            canUseCardDetailsForm: !!canUseCardDetailsForm,
                        },
                    });
                    if (iframeRef.current) {
                        startObserving(iframeRef.current);
                    }
                }
                if (data.closeModal && onCloseForm) {
                    onCloseForm();
                }
                if (data.success && onSuccess) {
                    scrollToTop();
                    setAlertMessage({
                        paymentId: card.paymentId,
                        alertStatus: TAlertStatus.SUCCESS,
                        text: HD_PASS_SUCCESS_AUTH_MSG.message,
                    });
                    onSuccess();
                }
            }
        };
        window.addEventListener('message', handleIFrameMessages);
        return () => {
            window.removeEventListener('message', handleIFrameMessages);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const SkeletonLoader = () => {
        return (React.createElement(Skeleton, { className: "sui-grow", "data-testid": "skeleton-loader" },
            React.createElement(SkeletonBlock, { aspect: "wide" }),
            React.createElement("div", { className: "sui-w-40" },
                React.createElement(SkeletonLine, { numberOfLines: 3 }))));
    };
    return (React.createElement("div", null,
        isIframeLoading && React.createElement(SkeletonLoader, null),
        React.createElement("iframe", { ref: (el) => {
                iframeRef.current = el;
            }, className: "sui-w-full sui-select-none", title: "HD Pass", src: HD_PASS_AUTH_IFRAME_URL, id: "hd-pass-frame", height: iframeHeight + 16 })));
};
